import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import classnames from 'classnames'
import { generateInputErrorId } from 'lp-components'

const propTypes = {
  children: PropTypes.node.isRequired,
  invalid: PropTypes.bool.isRequired,
  /** When set with invalid, fieldset aria-describedby includes the matching InputError id */
  groupValidationErrorId: PropTypes.string,
}

const defaultProps = {
  invalid: false,
  groupValidationErrorId: undefined,
}

// Wraps checkboxes that appear togther visually in the UI but are 2 separate fields
// Most common use case: a form with a CheckboxWithText input
function CheckboxFieldset({
  invalid,
  groupValidationErrorId,
  children,
  ...rest
}) {
  const { 'aria-describedby': existingDescribedBy, ...fieldsetProps } = rest
  const groupDesc =
    invalid && groupValidationErrorId
      ? generateInputErrorId(groupValidationErrorId)
      : null
  const ariaDescribedBy =
    [existingDescribedBy, groupDesc].filter(Boolean).join(' ') || undefined

  return (
    <fieldset
      className={classnames('checkboxes-fieldset', {
        'fieldset-wide-error': invalid,
      })}
      {...fieldsetProps}
      aria-describedby={ariaDescribedBy}
    >
      {children}
    </fieldset>
  )
}

CheckboxFieldset.propTypes = propTypes
CheckboxFieldset.defaultProps = defaultProps

export default pure(CheckboxFieldset)
